import { GiveButterWidget } from "./give-butter/GiveButterWidget"

export const HeroBanner: React.FC = () => {
    return (
        <section
            id="home"
            className="section-banner"
        >

            <div className="container">

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="banner-content wow fadeInUp">
                            <h2>
                                YOUR <span>DONATION</span> supports a new or existing Black Hills <span>Robotics</span> team!
                            </h2>
                            <h3>
                                Your donation helps us lower the barrier to entry, so that every community in the Black Hills
                                that wants to compete in Robotics can.
                                <br />
                                <br />
                                Increased competition leads to increased talent, and all of Black Hills Robotics "leveling up".
                                <br />
                                <br />

                                Lets help our youth discover a passion that can translate into a professional career and nurture soft skills they'll leverage the rest of their lives!
                            </h3>

                            <div className="slider-button">
                                <a href="#about-us" className="btn btn-custom">Learn More</a>
                                <div style={{ marginTop: 10 }}>
                                    <GiveButterWidget id="LYz01g" />
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </section>
    )
}